<template>
  <div class="bg">
    <div v-show="showPagination !== 0">
      <div class="content">
        <van-swipe-cell
          v-for="(item, index) in list"
          :key="index"
          :name="item.id"
        >
          <el-card>
            <el-row>
              <div @click="goDetail(item.projectId)">
                <el-col :span="20">
                  <span>项目名称：{{ item.projectName }}</span>
                </el-col>
                <el-col :span="24">
                  <span>在册人员：{{ item.registeredCount }} 人</span>
                </el-col>
                <el-col :span="24">
                  <span>今日出勤：{{ item.todayCount }} 人</span>
                </el-col>
                <el-col :span="24">
                  <span>正在施工：{{ item.underConstruction }} 人</span>
                </el-col>
                <el-col :span="24">
                  <span>更新时间：{{ item.updateTime }}</span>
                </el-col>
                <el-col />
              </div>
            </el-row>
          </el-card>
          <el-card v-show="showPagination == 0" body-style="text-align:center">
            <span>暂无数据</span>
          </el-card>
        </van-swipe-cell>
      </div>
    </div>
    <el-card v-show="showPagination == 0" body-style="text-align:center">
      <span>暂无数据</span>
    </el-card>
    <div style="margin-top: 10px; text-align: right">
      <el-button
        v-show="showPagination == 0"
        size="mini"
        type="primary"
        @click="goBack"
      >
        返回
      </el-button>
    </div>
  </div>
</template>
<script>
  import { summaryData } from "@/api/app/weixin";
  export default {
    data() {
      return {
        showPagination: 0,
        userId: this.$route.query.userId,
        createTime: this.$route.query.createTime,
        list: [],
      };
    },
    created() {
      this.$store.dispatch("getConfig").then(() => {
        this.getSummaryData();
      });
    },
    mounted() {
      //this.itemList();
    },
    methods: {
      // 获取班组列表
      getSummaryData() {
        summaryData({ userId: this.userId, createTime: this.createTime }).then(
          (res) => {
            this.list = res.data;
            if (this.list.length > 0) {
              this.showPagination = 1;
            } else {
              this.showPagination = 0;
            }
          }
        );
      },
      // 返回
      goBack() {
        if (this.name !== "") {
          location.reload();
        } else {
          this.$router.back();
        }
      },
      // 跳转到参建单位详情
      goDetail(projectId) {
        this.$router.push({
          path: "/teamAttendanceData/" + projectId + "/" + this.createTime,
        });
      },
    },
  };
</script>
<style lang="less" scoped>
  .bg {
    margin-bottom: 40px;
    padding: 10px;
    min-height: 100vh;
    background-color: #f0f0f0;
  }
  // .el-button + .el-button {
  //   margin: 0;
  // }
  /deep/ .el-checkbox__inner {
    width: 19px;
    height: 19px;
    border-radius: 50%;
  }
  /deep/ .el-checkbox__inner::after {
    top: 4px;
    left: 7px;
  }

  .button {
    width: 100%;
    margin-bottom: 10px;
    text-align: right;
    i {
      font-size: 24px;
      color: #606266;
    }
    .van-field:nth-child(1) {
      margin-top: 45px;
    }
    .van-popup {
      padding-bottom: 30px;
    }
    .searchBtn {
      margin-top: 20px;
    }
    /deep/ .van-dialog__content {
      width: 100%;
      display: flex;
      padding: 10px;
      flex-wrap: wrap;
    }
  }
  .el-checkbox {
    margin-bottom: 5px;
  }
  .content {
    /deep/ .el-checkbox__input {
      position: absolute;
      left: -10px;
    }
    .van-button {
      height: 100%;
    }
    .el-card {
      margin-bottom: 10px;
      .van-button {
        height: 100%;
      }
      .el-checkbox:last-of-type {
        margin: 0px;
      }
      .el-col {
        margin-bottom: 3px;
      }
      .el-col:last-child {
        top: 20px;
        left: 10px;
        text-align: end;
        position: relative;
      }
    }
  }
  // 分页
  /deep/ .el-pagination {
    padding: 0;
    overflow: hidden;
  }
  /deep/ .el-pagination .el-select .el-input {
    margin: 0;
  }
</style>
